import { CheckoutContext } from '@/context/CheckoutContext';
import { CheckoutRedirectOrderStatus } from '@/constants/checkoutRedirectOrderStatus';
import type { ICheckoutContext } from '@/types/context';
import { redirectUser } from '@/utils/location';
import { shouldRedirectUser } from '@/utils/redirect';
import { useContext, useEffect, useState } from 'react';
import { useRedirectLink } from './useRedirectLink';

export function useAutoRedirect() {
  const context = useContext(CheckoutContext);
  const featureFlags = context.featureFlags ?? ({} as ICheckoutContext['featureFlags']);
  const { fullyRedirectLink } = useRedirectLink(CheckoutRedirectOrderStatus.SUCCESS);
  const [isRedirectAttempted, setIsRedirectAttempted] = useState(!shouldRedirectUser(featureFlags));

  useEffect(() => {
    if (!shouldRedirectUser(featureFlags) || !fullyRedirectLink) {
      return;
    }
    redirectUser(fullyRedirectLink);
    const timeout = setTimeout(() => {
      setIsRedirectAttempted(true);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [fullyRedirectLink, featureFlags]);

  return { isRedirectAttempted, fullyRedirectLink };
}
